import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import "../../../styles/navbar.scss";
import { Link as Li } from "react-router-dom";
import { useHistory } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import Accordion from "@material-ui/core/Accordion";
import { split } from "lodash";
import { useGAEventsTracker } from "../../../util/gtag";
import ModalNewContactUs from "../../pages/Modalpopup/ModalNewContactUs";
import baseUrl from "../../config/config";

const useStyles = makeStyles(() => ({
  title: {
    flexGrow: 1,
  },
  header: {
    backgroundColor: "#fff",
    color: "black",
    "@media (max-width: 900px)": {
      paddingLeft: 0,
    },
  },
  logo: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: 600,
    color: "black",
    textAlign: "left",
    width: "100%",
  },
  menuButton: {
    fontWeight: 700,
    size: "18px",
    marginLeft: "38px",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

export default function NewNavbar(props) {
  const GAEventTracker = useGAEventsTracker(window.location.pathname);
  const GAEventTrackerContact = useGAEventsTracker(
    window.location.pathname + "/Contact Us"
  );
  const GAEventTrackerHowItWorks = useGAEventsTracker(
    window.location.pathname + "/How It Works"
  );
  const GAEventTrackerFaq = useGAEventsTracker(
    window.location.pathname + "/FAQs"
  );

  const history = useHistory();
  const [openSubmit, setOpenSubmit] = React.useState(false);
  const [drawerstate, setDrawerState] = useState(false);
  const handleClickOpen2 = () => {
    setOpenSubmit(!openSubmit);
  };
  const { header, logo, toolbar } = useStyles();
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const { mobileView } = state;
  const handleHome = () => {
    setDrawerState(!drawerstate);
    setTimeout(() => {
      let ele = document.getElementById("new-home");
      ele.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }, 100);
  };
  const menuClicked = (e) => {
    e.stopPropagation();
  };
  const handleMobileMenu = (event, state) => {
    event.stopPropagation();
    setDrawerState(state);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
  };
  const handleFaqMobile = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      history.push(`/lender/${props?.partner?.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("faq");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };
  const handleHowItWorks = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      history.push(`/lender/${props?.partner?.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("trade");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };
  const handleDesktopHowItWorks = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      history.push(`/lender/${props?.partner?.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("trade");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };
  const handleDesktopFaq = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      history.push(`/lender/${props?.partner?.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("faq");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };
  const handleWhyWorkWithUs = () => {
    setDrawerState(!drawerstate);
    const url = window.location.href;
    const urlName = new URL(url);
    const urlNamePath = split(urlName.pathname, "/");
    if (urlNamePath[3] === "calculator") {
      history.push(`/lender/${props?.partner?.url_path}`);
      setTimeout(() => {
        let ele = document.getElementById("whyworkwithus");
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 200);
    }
  };

  const mobileNav = () => {
    return (
      <div className="new-mob-navbar inter">
        <div className="partner_navbar_mob">
          <div>
            {props?.pathname && props?.pathname.length !== 0 ? (
              props?.partner?.url_path === "hometown" ? (
                <div className="partner_navbar_sub_mob">
                  <div>
                    <img
                      src={`${baseUrl.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "120px",
                        height: "68px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-3">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="142px"
                        height="45px"
                        className="mt-3"
                      ></img>
                    </Li>
                  </div>
                </div>
              ) : props?.partner?.url_path === "nrl" ||
                props?.partner?.url_path === "firstfederal" ? (
                <div className="partner_navbar_sub_mob">
                  <div>
                    <img
                      src={`${baseUrl.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "110px",
                        height: "50px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-3">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="140px"
                        height="42px"
                        className="mt-3"
                      ></img>
                    </Li>
                  </div>
                </div>
              ) : props?.pathname?.url_path === "teamnikkijames" ? (
                <div className="partner_navbar_sub_mob">
                  <div>
                    <img
                      src={`${baseUrl.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "120px",
                        height: "68px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-1">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="98px"
                        height="35px"
                        className="mt-1"
                      ></img>
                    </Li>
                  </div>
                </div>
              ) : props?.partner?.url_path === "gvc" ? (
                <div className="partner_navbar_sub_mob">
                  <div style={{ display: "flex", height: "35px" }}>
                    <img
                      src={`${baseUrl.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "150px",
                        height: "80px",
                        objectFit: "contain",
                        paddingBottom: "50px",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-1">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="98px"
                        height="35px"
                        className="mt-1"
                      ></img>
                    </Li>
                  </div>
                </div>
              ) : props?.partner?.url_path === "rvwarburton" ? (
                <div className="partner_navbar_sub_mob">
                  <div style={{ display: "flex", height: "35px" }}>
                    <img
                      src={`${baseUrl.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "40px",
                        height: "90px",
                        objectFit: "contain",
                        paddingBottom: "50px",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-1">+</div>
                  <div style={{ display: "flex", height: "35px" }}>
                    <img
                      src="/assets/partner_logos/Warburton.png"
                      alt="Logo"
                      className=""
                      style={{
                        width: "66px",
                        height: "36px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus mt-1">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="98px"
                        height="35px"
                        className="mt-1"
                      ></img>
                    </Li>
                  </div>
                </div>
              ) : (
                <div className="partner_navbar_sub_mob">
                  <div>
                    <img
                      src={`${baseUrl.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "120px",
                        height: "68px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </div>
                  <div className="px-2 partner_header_plus">+</div>
                  <div className="partner_header_logo_calque">
                    <Li
                      to={`/${props?.partner?.url_path}`}
                      onClick={(e) => {
                        GAEventTracker("Home");
                      }}
                    >
                      <img
                        src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                        alt="Logo"
                        width="115px"
                        height="35px"
                      ></img>
                    </Li>
                  </div>
                </div>
              )
            ) : (
              ""
            )}
          </div>
          <div>
            <div
              onClick={(e) => handleMobileMenu(e, !drawerstate)}
              onKeyDown={(e) => handleMobileMenu(e, !drawerstate)}
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center justify-content-center"
            >
              <MenuIcon />
            </div>
          </div>
        </div>
        {drawerstate === true && (
          <div
            id="mobilemenu"
            style={{
              position: "absolute",
              width: "100%",
              backgroundColor: "#fff",
              top: "3.5rem",
              borderTop: "1px solid #eee",
            }}
            onClick={menuClicked}
          >
            <div id="menuAccordian">
              <Accordion className="p-2 pl-4">
                <Li
                  activeclass="active"
                  to={`/${props?.partner?.url_path}`}
                  href={`/${props?.partner?.url_path}`}
                  onClick={(e) => {
                    GAEventTracker("Home");
                    handleHome();
                  }}
                  spy={true}
                  smooth="true"
                  offset={-70}
                  className={
                    props?.partner?.url_path === "c2" ? "ftpolar-semibold" : ""
                  }
                  duration={500}
                >
                  Home
                </Li>
              </Accordion>
              <Accordion className="p-2 pl-4">
                <Link
                  activeclass="active"
                  to="whyworkwithus"
                  spy={true}
                  smooth="true"
                  offset={-70}
                  onClick={(e) => {
                    GAEventTrackerHowItWorks("Header", 1);
                    handleWhyWorkWithUs();
                  }}
                  className={
                    props?.partner?.url_path === "c2" ? "ftpolar-semibold" : ""
                  }
                  duration={500}
                >
                  Why Work With Us?
                </Link>
              </Accordion>
              <Accordion className="p-2 pl-4">
                <Link
                  activeclass="active"
                  to="trade"
                  spy={true}
                  smooth="true"
                  offset={-70}
                  onClick={(e) => {
                    GAEventTrackerHowItWorks("Header", 1);
                    handleHowItWorks();
                  }}
                  className={
                    props?.partner?.url_path === "c2" ? "ftpolar-semibold" : ""
                  }
                  duration={500}
                >
                  How It Works
                </Link>
              </Accordion>

              <Accordion className="p-2 pl-4">
                <Link
                  activeclass="active"
                  className={
                    props?.partner?.url_path === "c2"
                      ? "ftpolar-semibold faqs"
                      : "faqs"
                  }
                  to="faq"
                  spy={true}
                  smooth="true"
                  offset={-70}
                  duration={500}
                  onClick={(e) => {
                    GAEventTrackerFaq("Header", 1);
                    handleFaqMobile();
                  }}
                >
                  FAQs
                </Link>
              </Accordion>
              <Accordion className="p-2 pl-4">
                <Li
                  activeclass="active"
                  onClick={(e) => {
                    GAEventTrackerContact("Contact Us", 1);
                    handleClickOpen2();
                  }}
                >
                  Contact
                </Li>
              </Accordion>
            </div>
          </div>
        )}
      </div>
    );
  };

  const desktopNav = () => {
    return (
      <Toolbar className={`new-navbar inter ${toolbar}`}>
        <div className="col-6">
          <Typography variant="h6" component="h1" className={logo}>
            <div className="login_img d-flex align-items-center justify-content-start">
              {props.pathname && props.pathname.length !== 0 ? (
                <>
                  <Li
                    to={`/${props?.partner?.url_path}`}
                    style={
                      props?.partner?.url_path === "gvc"
                        ? { display: "flex" }
                        : {}
                    }
                    onClick={(e) => {
                      GAEventTracker("Home");
                    }}
                  >
                    <img
                      src={`${baseUrl.mainUrl}${props?.partner?.logo}`}
                      alt="Logo"
                      className=""
                      style={{
                        width: "110px",
                        height: "68px",
                        objectFit: "contain",
                      }}
                    ></img>
                  </Li>
                  <p className="px-2 m-0">+</p>
                </>
              ) : (
                ""
              )}
              <Li
                to={`/${props?.partner?.url_path}`}
                onClick={(e) => {
                  GAEventTracker("Home");
                }}
              >
                <img
                  src="https://calque-asset-storage-prod.s3.us-east-1.amazonaws.com/branding-logo/calque-logo.webp"
                  alt="Logo"
                  width="100px"
                  height="35px"
                ></img>
              </Li>
            </div>
          </Typography>
        </div>
        <div className="col-6 d-flex justify-content-end align-items-center ipad-res">
          <div className="w-100 d-flex justify-content-between align-items-center global-nav">
            <Link
              activeclass="active"
              className="NavHeader"
              to="whyworkwithus"
              spy={true}
              smooth="true"
              offset={-70}
              onClick={(e) => {
                GAEventTrackerHowItWorks("Header", 1);
                handleWhyWorkWithUs();
              }}
              duration={500}
              style={{ fontWeight: "500" }}
            >
              WHY WORK WITH US?
            </Link>
            <Link
              activeclass="active"
              className="NavHeader"
              to="trade"
              spy={true}
              smooth="true"
              offset={-70}
              onClick={(e) => {
                GAEventTrackerHowItWorks("Header", 1);
                handleDesktopHowItWorks();
              }}
              duration={500}
              style={{ fontWeight: "500" }}
            >
              HOW IT WORKS
            </Link>
            <Link
              activeclass="active"
              className="faqs"
              to="faq"
              spy={true}
              smooth="true"
              offset={-70}
              onClick={(e) => {
                GAEventTrackerFaq("Header", 1);
                handleDesktopFaq();
              }}
              duration={500}
              style={{ fontWeight: "500" }}
            >
              FAQs
            </Link>
            <Button
              variant="contained"
              disableelevation="true"
              className="navbar-contact-btn"
              onClick={(e) => {
                GAEventTrackerContact("Contact Us", 1);
                handleClickOpen2();
              }}
              style={{
                color: "white",
                backgroundColor: `${
                  props.partner && props.partner.secondary_color
                    ? props.partner.secondary_color
                    : "#2A83C2"
                }`,
              }}
            >
              Contact
            </Button>
          </div>
        </div>
      </Toolbar>
    );
  };

  useEffect(() => {
    document.addEventListener("click", function (e) {
      setDrawerState(false);
    });
  });

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 822
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  return (
    <AppBar className={header}>
      {mobileView ? mobileNav() : desktopNav()}
      <ModalNewContactUs
        open={openSubmit}
        onClose={handleClickOpen2}
      />
    </AppBar>
  );
}
